/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_IdInputs */

const en_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Project Id`)
};

const fr_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du projet d’équipe`)
};

const de_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teamprojekt-ID`)
};

const it_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID progetto di squadra`)
};

const ru_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор командного проекта`)
};

const es_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación del proyecto de equipo`)
};

const zh_cn2_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队项目 ID`)
};

const ja_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームプロジェクトID`)
};

const hi_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रोजेक्ट आईडी`)
};

const pt_pt2_team_project_id = /** @type {(inputs: Team_Project_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do projeto da equipe`)
};

/**
* | output |
* | --- |
* | "Team Project Id" |
*
* @param {Team_Project_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_id = /** @type {((inputs?: Team_Project_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_id(inputs)
	if (locale === "de") return de_team_project_id(inputs)
	if (locale === "it") return it_team_project_id(inputs)
	if (locale === "ru") return ru_team_project_id(inputs)
	if (locale === "es") return es_team_project_id(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_id(inputs)
	if (locale === "ja") return ja_team_project_id(inputs)
	if (locale === "hi") return hi_team_project_id(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_id(inputs)
	return en_team_project_id(inputs)
});